import React, {useEffect, useState} from 'react';
import Input from '../Input';
import CustomSelect from '../CustomSelect';
import {useAssignFboWithCorporateMutation} from '../../store/builder/inspections.api';
import {useErrorHandler} from '../../global/ErrorsHandler';
import {toast} from 'react-toastify';
import {setLoader} from '../../store/builder/reducer';
import {useDispatch} from 'react-redux';
import {useTranslation} from '../../hooks/useTranslation';
const AssignWithCorporate = ({
  exit,
  currentItem,
  corporateData,
  getAgencies,
}) => {
  const dispatch = useDispatch();
  const [chosenCorporate, setChosenCorporate] = useState(null);
  const {t} = useTranslation();
  const [
    assignCorporate,
    {
      data: assignCorporateData,
      error: assignCorporateError,
      isLoading: assignCorporateIsLoading,
      isSuccess: assignCorporateIsSuccess,
      isError: assignCorporateIsError,
    },
  ] = useAssignFboWithCorporateMutation();

  const [errorHandler, setErrorHandler] = useErrorHandler([
    assignCorporateError,
  ]);

  const handleSubmit = () => {
    dispatch(setLoader(true));
    if (chosenCorporate) {
      assignCorporate({
        agency_id: currentItem.id,
        corporate_id: chosenCorporate,
      }).finally(() => {
        dispatch(setLoader(false));
        toast.success(t('assignCorporate.successfullyAssigned'));
        getAgencies();
        exit();
      });
    } else {
      setChosenCorporate(null);
      toast.error(t('assignCorporate.chooseCorporate'));
    }
  };

  return (
    <div className='modal modal-fbo'>
      <div className='modal__content'>
        <div className='modal__content-head'>
          <p>{t('assignCorporate.title')}</p>
          <img
            className='modal__content-exit'
            src='/assets/icons/close.svg'
            alt='close'
            onClick={exit}
          />
        </div>
        <div className={`modal__content-body`}>
          <Input
            label={t('assignCorporate.fbo')}
            name={'fbo_id'}
            id={'fbo_id'}
            placeholder={currentItem?.title}
            containerWidth={'100%'}
            readOnly={true}
          />
          <CustomSelect
            label={t('assignCorporate.corporate')}
            options={corporateData?.map(item => ({
              label: item?.title,
              value: item?.id,
            }))}
            name={'corporate_id'}
            onChange={e => setChosenCorporate(e.target.value)}
            placeholder={t('assignCorporate.corporate')}
          />
        </div>
        <div className='modal__content-bottom'>
          <button className='close' onClick={exit}>
            {t('assignCorporate.close')}
          </button>
          <button className='save' onClick={handleSubmit}>
            {t('assignCorporate.save')}
          </button>
        </div>
      </div>
      <div className='modal__bg'></div>
    </div>
  );
};

export default AssignWithCorporate;
